import React from 'react';
import { Link } from 'react-router-dom';

export default function AdminDashboard() {
  const stats = [
    { label: 'Total de Produtos/Serviços', value: '0', icon: 'ri-shopping-bag-line', color: 'text-blue-600', bg: 'bg-blue-50' },
    { label: 'Itens no Portfólio', value: '0', icon: 'ri-image-line', color: 'text-purple-600', bg: 'bg-purple-50' },
    { label: 'Usuários Admin', value: '1', icon: 'ri-user-settings-line', color: 'text-green-600', bg: 'bg-green-50' },
  ];

  return (
    <div className="flex min-h-screen bg-gray-50">
      <aside className="w-64 bg-[#1e3a8a] text-white hidden md:flex flex-col">
        <div className="p-6 border-b border-blue-800">
          <h2 className="text-xl font-bold tracking-tight uppercase">JR Gráfica</h2>
          <p className="text-blue-200 text-xs">Painel Administrativo</p>
        </div>
        
        <nav className="flex-1 px-4 py-6 space-y-2">
          <Link to="/admin/dashboard" className="flex items-center gap-3 p-3 bg-blue-800 rounded-lg">
            <i className="ri-dashboard-line text-lg"></i> Dashboard
          </Link>
          <Link to="/admin/produtos" className="flex items-center gap-3 p-3 hover:bg-blue-800 rounded-lg transition-colors">
            <i className="ri-shopping-cart-2-line text-lg"></i> Produtos & Serviços
          </Link>
          <Link to="/admin/portfolio" className="flex items-center gap-3 p-3 hover:bg-blue-800 rounded-lg transition-colors">
            <i className="ri-camera-lens-line text-lg"></i> Portfólio
          </Link>
        </nav>

        <div className="p-4 border-t border-blue-800">
          <button className="flex items-center gap-3 p-3 w-full text-red-300 hover:text-red-100 transition-colors">
            <i className="ri-logout-box-r-line text-lg"></i> Sair
          </button>
        </div>
      </aside>

      <main className="flex-1 p-8">
        <header className="flex justify-between items-center mb-10">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Resumo do Sistema</h1>
            <p className="text-gray-500 text-sm">Gerencie seus produtos, serviços e portfólio.</p>
          </div>
          <Link to="/" className="flex items-center gap-2 text-blue-600 font-medium hover:underline">
            Ver site público <i className="ri-external-link-line"></i>
          </Link>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {stats.map((stat, i) => (
            <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-400">{stat.label}</p>
                  <p className="text-3xl font-bold mt-1">{stat.value}</p>
                </div>
                <div className={`${stat.bg} ${stat.color} p-4 rounded-xl`}>
                  <i className={`${stat.icon} text-2xl`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <h3 className="text-lg font-bold mb-6 text-gray-700">Acesso Rápido</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Link to="/admin/produtos" className="flex items-center justify-between p-5 border rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all group">
              <div className="flex items-center gap-4">
                <i className="ri-list-settings-line text-2xl text-gray-400 group-hover:text-blue-500"></i>
                <span className="font-semibold text-gray-600">Gerenciar Produtos & Serviços</span>
              </div>
              <i className="ri-arrow-right-s-line text-gray-300"></i>
            </Link>
            <Link to="/admin/portfolio" className="flex items-center justify-between p-5 border rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all group">
              <div className="flex items-center gap-4">
                <i className="ri-gallery-line text-2xl text-gray-400 group-hover:text-blue-500"></i>
                <span className="font-semibold text-gray-600">Gerenciar Portfólio</span>
              </div>
              <i className="ri-arrow-right-s-line text-gray-300"></i>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}